import { eduIDApi } from "./common";
export const resetPasswordApi = eduIDApi.injectEndpoints({
    endpoints: (builder) => ({
        getResetPasswordState: builder.query({
            query: () => ({
                url: "/",
            }),
            extraOptions: { service: "resetPassword" },
        }),
        getResetPasswordCaptchaRequest: builder.query({
            query: () => ({
                url: "get-captcha",
                body: {},
            }),
            extraOptions: { service: "resetPassword" },
        }),
        sendResetPasswordCaptchaResponse: builder.query({
            query: (body) => ({
                url: "captcha",
                body,
            }),
            extraOptions: { service: "resetPassword" },
        }),
        postSetNewPasswordExternalMfa: builder.query({
            query: (body) => ({
                url: "new-password-extra-security-external-mfa",
                body,
            }),
            extraOptions: { service: "resetPassword" },
        }),
        postSetNewPasswordExtraSecurityToken: builder.query({
            query: (body) => ({
                url: "new-password-extra-security-token",
                body,
            }),
            extraOptions: { service: "resetPassword" },
        }),
        postSetNewPassword: builder.query({
            query: (body) => ({
                url: "new-password",
                body,
            }),
            extraOptions: { service: "resetPassword" },
        }),
        verifyEmailLink: builder.query({
            query: (body) => ({
                url: "verify-email",
                body,
            }),
            extraOptions: { service: "resetPassword" },
        }),
        requestEmailLink: builder.query({
            query: (body) => ({
                url: "",
                body,
            }),
            extraOptions: { service: "resetPassword" },
        }),
    }),
});
